export default function updateAppUser(extraData = {}) {
  if (!window.appUser) window.appUser = {};

  window.appUser = {
    ...window.appUser,
    ...extraData,
  };
}
